enum BusinessBranchAnalyticEventType {
    ProfileView = 0,
    PhoneClicked = 2,
    EmailClicked = 3,
    WebsiteClicked = 4,
    Other = 5
}

export default BusinessBranchAnalyticEventType
